@use '@fpsm/cxy-scss' as cxy;

.rangeSelectFilterContainer {
  @include cxy.stack(var(--cxy-spacing-1));
}

.rangeSelectFilterLabel {
  font-size: var(--cxy-fontSize-s);
}

.rangeSelectFilterItems {
  display: flex;
  gap: var(--cxy-spacing-4);
}

.rangeSelectFilterItem {
  flex: 1;
}
